import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';
import { NavItem } from '../../../Common/Layout/components/Navbar/navbar.component';
import { UserStateModel } from '../../../Core/Users/models/user-state.model';
import { HubspotFormTypeEnum } from '../../../Common/Misc/enums/hubspot-form-type.enum';

export const mediaIntelligenceNavItem: NavItem = {
    label: 'Core.navigation.mediaIntelligence',
    id: 'primaryNavMediaIntelligence',
    permissions: [
        userPermissionsEnum.advancedMonitoring
    ],
    items: [
        {
            label: 'Core.navigation.mediaIntelligence.search',
            icon: 'fa-duotone fa-regular fa-file-magnifying-glass',
            subLabel: 'Core.navigation.mediaIntelligence.search.subLabel',
            routerLink: '/Monitoring/search',
            id: 'primaryNavSearch'
        },
        {
            label: 'Core.navigation.mediaIntelligence.topics',
            icon: 'fa-kit-duotone fa-agpr-topics',
            subLabel: 'Core.navigation.mediaIntelligence.topics.subLabel',
            routerLink: '/Monitoring/topics',
            id: 'primaryNavTopics'
        },
        {
            label: 'Core.navigation.mediaIntelligence.coverage',
            icon: 'fa-kit-duotone fa-agpr-folders',
            subLabel: 'Core.navigation.mediaIntelligence.coverage.subLabel',
            routerLink: '/Monitoring/mentions',
            id: 'primaryNavMentions'
        },
        {
            label: 'Core.navigation.mediaIntelligence.briefings',
            icon: 'fa-kit-duotone fa-agpr-briefings',
            subLabel: 'Core.navigation.mediaIntelligence.briefings.subLabel',
            routerLink: '/Monitoring/briefings',
            id: 'primaryNavBriefings'
        },
        {
            label: 'Core.navigation.mediaIntelligence.alerts',
            icon: 'fa-duotone fa-regular fa-bell-exclamation',
            subLabel: 'Core.navigation.mediaIntelligence.alerts.subLabel',
            routerLink: '/Monitoring/alerts',
            id: 'primaryNavAlerts'
        },
        {
            label: 'Core.navigation.mediaIntelligence.subscriptions',
            icon: 'fa-duotone fa-regular fa-envelope-open-text',
            subLabel: 'Core.navigation.mediaIntelligence.subscriptions.subLabel',
            routerLink: '/Monitoring/subscriptions',
            id: 'primaryNavSubscriptions',
            permissions: [
                userPermissionsEnum.mediaSubscriptions
            ]
        },
        {
            label: 'Core.navigation.mediaIntelligence.reports',
            icon: 'fa-kit-duotone fa-agpr-reports',
            subLabel: 'Core.navigation.mediaIntelligence.reports.subLabel',
            routerLink: '/Report/reports',
            id: 'primaryNavReports',
        },
        {
            label: 'Core.navigation.mediaIntelligence.automationAgents',
            icon: 'fa-kit-duotone fa-agpr-ai-generic',
            subLabel: 'Core.navigation.mediaIntelligence.automationAgents.subLabel',
            routerLink: '/Agents',
            id: 'primaryNavAutomationAgents',
            // The agentic feature is provisioned on the account, not on the user. When it is not
            // provisioned the item stays in the menu behind a lock, and clicking it upsells instead of navigating
            showFunction(userStateModel: UserStateModel) {
                return userStateModel.account.permissions.includes(userPermissionsEnum.agenticFeature);
            },
            upsellMessage: 'Core.navigation.mediaIntelligence.automationAgents.upsell.message',
            upsellPopup: {
                icon: 'fa-kit-duotone fa-agpr-ai-generic',
                heading: 'Core.navigation.mediaIntelligence.automationAgents.upsell.heading',
                message: 'Core.navigation.mediaIntelligence.automationAgents.upsell.message',
                bullets: [
                    'Core.navigation.mediaIntelligence.automationAgents.upsell.bullet1',
                    'Core.navigation.mediaIntelligence.automationAgents.upsell.bullet2',
                    'Core.navigation.mediaIntelligence.automationAgents.upsell.bullet3'
                ],
                endMessage: 'Core.navigation.mediaIntelligence.automationAgents.upsell.wantToAccess',
                featureName: 'Automation Agents',
                hubspotFormType: HubspotFormTypeEnum.AGENTIC_FEATURES,
                confirmationHeading: 'Core.navigation.mediaIntelligence.automationAgents.upsell.confirmation.heading',
                confirmationMessage: 'Core.navigation.mediaIntelligence.automationAgents.upsell.confirmation.message'
            }
        },

    ],
    upsellMessage: 'Core.navigation.mediaIntelligence.unlock'
};
